/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Switch_OrgInputs */

const cs_portal_switch_org = /** @type {(inputs: Portal_Switch_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit organizaci`)
};

const en_portal_switch_org = /** @type {(inputs: Portal_Switch_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch organization`)
};

/**
* | output |
* | --- |
* | "Switch organization" |
*
* @param {Portal_Switch_OrgInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_switch_org = /** @type {((inputs?: Portal_Switch_OrgInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Switch_OrgInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_switch_org(inputs)
	return cs_portal_switch_org(inputs)
});